<template>
  <section>
    <div class="flex">
      <div class="w-2/3">
        <RevenueProjectionChart
          v-if="chartDataLoaded"
          :chartdata="chartData"
          :options="chartOptions"
        />
      </div>
      <div class="w-1/3 flex flex-col pl-8">
        <RevenueProjectionSummary />
        <RevenueProjectionForm
          @updateRevenueProjection="buildChartData"
          @fetchingRevenueProjection="chartDataLoaded = false"
        />
      </div>
    </div>
  </section>
</template>

<script type="text/babel">
import { mapState } from 'vuex'
import RevenueProjectionSummary from './RevenueProjectionSummary'
import RevenueProjectionForm from './RevenueProjectionForm'
import RevenueProjectionChart from './_charts/RevenueProjectionChart'

export default {
  name: 'RevenueProjection',
  components: {
    RevenueProjectionSummary,
    RevenueProjectionForm,
    RevenueProjectionChart,
  },
  data() {
    return {
      loading: false,
      chartDataLoaded: false,
      chartData: {},
      chartOptions: {
        legend: {
          display: false,
        },
        scales: {
          yAxes: [{
            scaleLabel: {
              display: true,
              labelString: 'Projected Revenue (USD)',
            },
          }],
        },
        tooltips: {
          callbacks: {
            label: function (tooltipItem) {
              return `$${tooltipItem.yLabel}`
            },
          },
        },
      },
    }
  },
  computed: {
    ...mapState({
      revenueProjection: state => state.payments.revenueProjection,
    }),
    baseTotal() {
      return this.revenueProjection ? `$${(this.revenueProjection.total / 100).toFixed(2)}` : ''
    },
    breakdown() {
      return this.revenueProjection.breakdown
    },
    actingAsMember() {
      return !this.$root.isSuperAdmin
    },
  },
  methods: {
    buildChartData() {
      if (this.breakdown) {
        this.chartData = {
          labels: this.breakdown.map(revenue => [`${revenue.interval_start} - ${revenue.interval_end}`]),
          datasets: [
            {
              label: '',
              data: this.breakdown.map(revenue => revenue.total / 100),
            },
          ],
        }
        this.chartDataLoaded = true
      }
    },
  },
}
</script>
